<script setup lang="ts">
const { value = 100, duration = 2, dynamic } = defineProps<{
  value?: number
  duration?: number
  dynamic?: boolean
}>()
const progress = ref(0)
watchEffect(() => {
  if (dynamic) return (progress.value = value)
  setTimeout(() => (progress.value = value), 10)
})
</script>

<template>
  <div class="meter w-full">
    <span :style="{ transitionDuration: `${progress ? duration : 0}s`, width: `${progress}%` }" />
  </div>
</template>

<style scoped>
.meter {
  box-sizing: content-box;
  height: 18px;
  position: relative;
  background: #e5e5e5;
  border-radius: 15px;
  overflow: hidden;
}
.meter > span {
  display: block;
  height: 100%;
  position: relative;
  @apply bg-primary;
}
.meter > span:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-image: linear-gradient(
    -45deg,
    rgba(255, 255, 255, 0.2) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.2) 50%,
    rgba(255, 255, 255, 0.2) 75%,
    transparent 75%,
    transparent
  );
  z-index: 1;
  background-size: 35px 35px;
  animation: move 2s linear infinite;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  overflow: hidden;
}
@keyframes move {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 35px 35px;
  }
}
</style>
